import React, { useState, useEffect, useRef } from 'react';
import { Formik, Form, Field } from 'formik';
import TypesenseInstantsearchAdapter from 'typesense-instantsearch-adapter/dist/typesense-instantsearch-adapter.min.js';
import { InstantSearch, ClearRefinements, Hits, useSearchBox, useHits } from 'react-instantsearch';
import UseScrollReveal from '../Common/UseScrollReveal ';

// Configure the Typesense Adapter
const typesenseInstantSearchAdapter = new TypesenseInstantsearchAdapter({
    server: {
        apiKey: 'nF0tmKPkPwGieB8DkIwci8gw6yh7bxeK', // Use search-only API key
        nodes: [
            {
                host: 'zm1oqtefa4prvd0gp-1.a2.typesense.net', // e.g. 'xxx.a1.typesense.net' or 'localhost'
                port: 443,        // e.g. 443 for HTTPS or 8108 for local
                protocol: 'https',  // 'https' or 'http'
            },
        ],
    },
    // Specify fields to search across in Typesense
    additionalSearchParameters: {
        query_by: 'vehicle_name,make,model', 
    },
});

const searchClient = typesenseInstantSearchAdapter.searchClient;

const CustomSearchBox = (props) => {
    const {
        query,
        refine,
        clear,
        currentRefinement
    } = useSearchBox(props);
    const [isFocused, setIsFocused] = useState(false);
    const [selectedHit, setSelectedHit] = useState("");
    const handleFocus = () => setIsFocused(true);
    const handleBlur = () => {
        setTimeout(() => setIsFocused(false), 200);
    };
    const handleHitClick = (hit) => {
        //console.log("handleHitClick", handleHitClick)
        setSelectedHit(hit.vehicle_name);
        refine(hit.vehicle_name);
        props.onHitClick(hit);
    };

    const { items, results, banner, sendEvent } = useHits(props);

    useEffect(() => {
        //console.log(items,results);
        if (items.length === 1) {
            setSelectedHit(items[0].vehicle_name);
            //refine(hit.vehicle_name);
            props.onHitClick(items[0]);
        }
    }, [items, results]);


    return (
        <>
            <div className="custom-searchbox position-relative">
                <input
                    type="search"
                    value={selectedHit || currentRefinement || ''}
                    onChange={event => {
                        refine(event.currentTarget.value);
                        setSelectedHit(event.currentTarget.value);
                    }}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    name="vehicle"
                    className="form-control"
                    placeholder="Enter Year Make Model Trim"
                />
                {isFocused && (
                    <Hits hitComponent={({ hit }) => (
                        <div className="hit" onClick={() => handleHitClick(hit)}>
                            <p>{hit.vehicle_name}</p>
                        </div>
                    )} />
                )}
            </div>
        </>
    );
}

const MyVehicleForm = ({ setGetQuoteModal, setSelectedValue, sotForm }) => {

    const [suggestions, setSuggestions] = useState([]);
    const vehicleOptions = [
        '2020 Honda Civic EX',
        '2019 Toyota Corolla LE',
        '2018 Ford Focus SE',
        '2022 Tesla Model 3',
        '2021 BMW 330i'
    ];

    const handleInputChange = (value, setFieldValue) => {
        setFieldValue('vehicle', value);

        // Filter suggestion list based on input
        const filtered = vehicleOptions.filter(option =>
            option.toLowerCase().includes(value.toLowerCase())
        );
        setSuggestions(value ? filtered : []);
    };

    const handleSuggestionClick = (value, setFieldValue) => {
        setFieldValue('vehicle', value);
        setSuggestions([]);
        console.log('Selected:', value);
        setGetQuoteModal(true);
        setSelectedValue(value);
    };

    const renderInputWithSuggestions = (setFieldValue) => (
        <div className='w-100 position-relative'>
            <Field
                type="text"
                name="vehicle"
                className="form-control"
                placeholder="Year Make Model Trim or VIN"
                onChange={(e) => handleInputChange(e.target.value, setFieldValue)}
                autoComplete="off"
            />
            {suggestions.length > 0 && (
                <ul className="suggestions-list">
                    {suggestions.map((item, index) => (
                        <li
                            key={index}
                            onClick={() => handleSuggestionClick(item, setFieldValue)}
                        >
                            {item}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );

    const formikRef = useRef(null);

    const handleSearchClick = (hit) => {
        formikRef.current.setFieldValue("vehicle", hit.vehicle_name);
        formikRef.current.setFieldValue("year", hit.year);
        formikRef.current.setFieldValue("make", hit.make);
        formikRef.current.setFieldValue("model", hit.model);
        formikRef.current.setFieldValue("trim", hit.trim);
        console.log(hit, formikRef.current.values);
    }

    const queryHook = (query, search) => {
        search(query);

        formikRef.current.setFieldValue("vehicle", query);
    };
    UseScrollReveal();
    return (
        <Formik
            initialValues={{
                vehicle: '',
                year: '',
                make: '',
                model: '',
                trim: ''
            }}
            innerRef={formikRef}
            onSubmit={(values, { resetForm }) => {
                console.log(values);

                setSuggestions([]);
                setGetQuoteModal(true);
                setSelectedValue(values.vehicle ?? "");
                resetForm();
            }}
        >
            {({ values, setFieldValue }) => (
                <Form className={`custom-form contact-form offer-form ${!sotForm ? 'mt-70' : ''}`} autoComplete="off">
                    <Field type="hidden" name="year" value={values.year} />
                    <Field type="hidden" name="make" value={values.make} />
                    <Field type="hidden" name="model" value={values.model} />
                    <Field type="hidden" name="trim" value={values.trim} />
                    <div className='form-group reveal wow fadeIn'>
                        <div className='cs-label mb-2'>Enter your vehicle info</div>
                        {!sotForm ? (
                            <InstantSearch indexName="vehicles" searchClient={searchClient} >
                                <CustomSearchBox onHitClick={handleSearchClick} queryHook={queryHook} />
                            </InstantSearch>
                        ) : (
                            <div className="d-flex align-items-center">
                                <InstantSearch indexName="vehicles" searchClient={searchClient} >
                                    <CustomSearchBox onHitClick={handleSearchClick} queryHook={queryHook} />
                                </InstantSearch>
                                <div className='reveal wow fadeIn'>
                                    <button
                                        className="theme-btn text-uppercase get-started-btn text-uppercase px-3 text-nowrap"
                                        type='submit'
                                    >
                                        GET My Value
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>

                    {!sotForm && (
                        <div className='reveal wow fadeIn'>
                            <button className="theme-btn text-uppercase get-started-btn w-100 text-uppercase" type='submit'>
                                GET My Value
                            </button>
                        </div>
                    )}
                </Form>
            )}
        </Formik>
    );
};

export default MyVehicleForm;
